import { Component, effect, inject, input, signal } from '@angular/core';
import { form, FormField, min, required } from '@angular/forms/signals';
import { TranslatePipe } from '@ngx-translate/core';
import { SaveButtonComponent } from '../../../../../../components/kit/button/save-button.component';
import { NumberInputComponent } from '../../../../../../components/kit/input/text-input-v2/number-input.component';
import {
    createDefaultOrganizationTrashSettings,
    OrganizationSettingsTrashType,
} from '@libs/types/src/organization/types/organization-settings/organization-settings-trash.type';
import {
    OrganizationSettingsObject,
} from '@libs/types/src/organization/object-type/organization/organization-settings.object';
import { OrganizationSettingsStore } from './organization-settings.store';
import { DEFAULT_TRASH_MINIMUM_RETENTION_DAYS } from '@libs/types/src/services/types/trash-settings.type';

@Component({
    selector: 'app-organization-trash-settings',
    templateUrl: './organization-trash-settings.component.html',
    imports: [
        FormField,
        NumberInputComponent,
        SaveButtonComponent,
        TranslatePipe,
    ],
})
export class OrganizationTrashSettingsComponent {

    private readonly store = inject(OrganizationSettingsStore);

    public readonly settings = input.required<OrganizationSettingsObject>();

    protected readonly formModel = signal<{ retentionDays: number | null }>({
        retentionDays: createDefaultOrganizationTrashSettings().retentionDays,
    });
    protected readonly minimumRetentionDays = signal(DEFAULT_TRASH_MINIMUM_RETENTION_DAYS);
    protected readonly formFields = form(this.formModel, schema => {
        required(schema.retentionDays);
        min(schema.retentionDays, () => this.minimumRetentionDays());
    });

    constructor() {
        effect(() => {
            const data = JSON.parse(this.settings().data || '{}') as Partial<OrganizationSettingsTrashType>;
            this.minimumRetentionDays.set(
                data.minimumRetentionDays ?? DEFAULT_TRASH_MINIMUM_RETENTION_DAYS,
            );
            this.formFields().reset({
                retentionDays: data.retentionDays ?? createDefaultOrganizationTrashSettings().retentionDays,
            });
        });
    }

    protected save(): void {
        if (this.formFields().invalid()) {
            this.formFields().markAsTouched();
            return;
        }

        const settings = this.settings();
        this.store.api.updateOrganizationSetting({
            key: settings.key,
            organizationId: settings.organizationId,
            data: JSON.stringify({
                retentionDays: this.formModel().retentionDays!,
            }),
        });
    }
}
